import React, { Component } from "react";
import { connect } from "react-redux";
import FormElement from "components/FormElement";
import { handleInputChange } from "actions/request";
import { hasCBSDDPtype } from "helpers/DeviceTypeHelper";
import { hasStringValue } from "helpers/RequestHelper";
import { checkDPSW } from "helpers/DateHelper";
import { emptyMsg } from "helpers/FormHelper";
import { makeEvent } from "libs/form";

class DpSwVersion extends Component {
  componentWillUpdate(nextProps) {
    const currentType = this.props.request.deviceType;
    const nextType = nextProps.request.deviceType;

    // device type was changed
    if (currentType !== nextType) {
      this.props.handleInputChange(
        makeEvent("isCBSDDPdevice", hasCBSDDPtype(nextType))
      );
    }
  }

  hasDpSwValue() {
    return hasStringValue(this.props.request, "dpSwVersion");
  }

  validate() {
    if (!this.props.user.canEditRequest) return null;

    return this.hasDpSwValue() ? null : "error";
  }

  render() {
    const { handleInputChange, request, user, labMode = false } = this.props;

    if (!request) return null;

    const isEmptyDpsw = !this.hasDpSwValue();

    // hide for vendors if is empty
    if (isEmptyDpsw && user.isVendor) return null;

    // hide for labs if is empty and user is not on enter test result page
    if (user.isLab && !labMode && isEmptyDpsw) return null;

    // available for `CBSD + DP` device type only
    if (!request.isCBSDDPdevice) return null;

    // hide field for staff if no hw/sw entered by lab yet
    const hasHwVersion = hasStringValue(request, "hwVersion");
    const hasSwVersion = hasStringValue(request, "swVersion");
    if (user.ctiaStaff && !hasHwVersion && !hasSwVersion) return null;

    // hide the field for already approved devices
    // before date we rolled out DPSW feature (10/29/2018)
    if (request.isApproved && !checkDPSW(request.completeDate)) return null;

    const getInputType = () => {
      // editable if user is lab and on enter result page
      if (labMode) return "text";

      // if user staff with enabled edit mode toggler
      if (user.ctiaStaff && user.canEditRequest) return "text";

      // readonly for others
      return "";
    };

    return (
      <FormElement
        type={getInputType()}
        id="dpSwVersion"
        label="DP SW Version"
        value={request.dpSwVersion}
        onChange={handleInputChange}
        validationState={this.validate()}
        validationMessage={emptyMsg}
      />
    );
  }
}

function mapStateToProps({ request, user }) {
  return { request, user };
}

export default connect(mapStateToProps, {
  handleInputChange
})(DpSwVersion);



// WEBPACK FOOTER //
// ./src/containers/testResult/DpSwVersion.js